import routes from './routes';
import { SetRoutes } from 'components';

const AcademyCategoriesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default AcademyCategoriesPages;
